// DEPENDENCIES
import React, { useState, useEffect } from 'react';
// COMPONENTS
// ICONS
import { HiChevronRight } from 'react-icons/hi';
import { BiSearchAlt2 } from 'react-icons/bi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import constants from "../../../../constants/constants";
//SERVICES AND HELPERS
import * as dashboardService from '../../../../services/dashboard/dashboardService';

var L = window.L;
L.mapquest.key = constants.MAPQUEST_KEY;

const JobLocationsAndMapsBlock = (props) => {

    useEffect(() => {
        dashboardService.getLatestLoginLocation().then(res => {
            createMap(res);
        })
    }, []);

    const createMap = (sessions) => {
        var map = L.mapquest.map('map', {
            center: [30.3886803239576, -91.04900000150919],
            layers: L.mapquest.tileLayer('map'),
            zoom: 10
        });

        sessions.forEach(x => {
            L.marker([x.latitude, x.longitude]).addTo(map)
                .bindPopup(x.fullName + " " + x.dateLoggedIn);
        })
    }

    return (
        <>
            <CustomBlock className="content-container--card-style large-card">
                <CustomBlock className="header-block">
                    <CustomBlock>
                        {/* <ContentHeader
                            subtitle="Location and Map"
                            headerSize="sm"
                            textHeaderStyle="pb-0"
                        /> */}
                    </CustomBlock>
                </CustomBlock>
                {/* <div className="row" id="map" style={{ height: '34vh' }}></div> */}
                <div className="row" style={{ height: '100%', zIndex: '0' }} id="map"></div>
            </CustomBlock>
        </>
    );
}

export default JobLocationsAndMapsBlock;